import { io } from "socket.io-client";
const baseURL = process.env.REACT_APP_API_BASE_URL;
console.log('Connecting to Socket.IO server at:', baseURL);

const socket = io(baseURL, {
  transports: ["websocket", "polling"]
});

socket.on("connect", () => {
  console.log("Socket connected successfully with ID:", socket.id);
});

socket.on("connect_error", (error) => {
  console.error("Socket connection error:", error.message);
});

socket.on("disconnect", (reason) => {
  console.log("Socket disconnected:", reason);
});

export default socket;